import { Divider, Modal, Typography, Button, message, Badge } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { FileDownloadIcon } from 'hugeicons-react';

const { Text } = Typography;

const MailboxModal = ({ open, onCancel, docs = [], autoOpen, operationId, refreshDocs }) => {
	const { t, i18n } = useTranslation();
	const userToken = useSelector((state) => state.auth.token);
	const [loadingDocs, setLoadingDocs] = useState({});

	const handleClose = () => {
		onCancel();
		if (autoOpen) {
			axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{ key: 'denialLetterModal', participant: 'process', value: false },
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.catch((err) => console.error('Failed to update denial letter modal state:', err));
		}
	};

	const setDocLoading = (docId, type, value) => {
		setLoadingDocs((prev) => ({ ...prev, [`${docId}-${type}`]: value }));
	};

	const handleDownloadDoc = async (doc) => {
		setDocLoading(doc.id, 'download', true);
		let downloaded = false;
		try {
			const urlResponse = await axios.get(
				`${env.api.url}/v1/documents/get-document-url/${doc.id}`,
				{ headers: { Authorization: `Bearer ${userToken}` } }
			);
			const url = urlResponse?.data?.data?.url;
			if (url) {
				window.open(url);
				downloaded = true;
			} else {
				message.error(t('mailbox.errorDownloadDoc'));
			}
		} catch (err) {
			console.error('Failed to download document:', err);
			message.error(t('mailbox.errorDownloadDoc'));
		} finally {
			setDocLoading(doc.id, 'download', false);
		}
		if (downloaded) {
			axios.patch(
				`${env.api.url}/docs/documents/update/${doc.id}`,
				{ tagsToRemove: ['unread'], tagsToAdd: ['read'] },
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
				.then(() => refreshDocs?.())
				.catch((err) => console.error('Failed to mark document as read:', err));
		}
	};

	const getOwnerLabel = (owner) => {
		if (!owner) return null;
		const match = owner.match(/^(owner|guarantor)(\d+)$/);
		if (!match) return null;
		const type = match[1] === 'owner' ? t('document.owner') : t('document.guarantor');
		return `${type} ${match[2]}`;
	};

	return (
		<Modal
			open={open}
			onCancel={handleClose}
			className="mailbox-modal"
			footer={null}
			width={460}
			title={t('notification.mailbox')}>
			{[...docs]
				.sort(
					(a, b) => (b?.tags?.includes('unread') ? 1 : 0) - (a?.tags?.includes('unread') ? 1 : 0)
				)
				.map((doc) => {
					const key = `documentTypes.${doc?.type}`;
					const hasTranslation = i18n.exists(key);
					return (
						<div key={doc.id}>
							<Divider style={{ margin: '8px 0', borderColor: '#E0E0E0' }} />
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									flexWrap: 'wrap'
								}}>
								<div style={{ display: 'flex', flexDirection: 'column', maxWidth: '60%' }}>
									<div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
										<Badge dot={doc?.tags?.includes('unread')} size="small" className="gb-badget" />
										<Text ellipsis={{ tooltip: true }} style={{ color: '#212121' }}>
											{hasTranslation ? t(key) : doc?.name}
										</Text>
									</div>
									{getOwnerLabel(doc?.owner) && (
										<Text
											type="secondary"
											style={{ fontSize: 12, marginLeft: 12, color: '#757575' }}>
											{getOwnerLabel(doc?.owner)}
										</Text>
									)}
								</div>
								<Button
									type="text"
									icon={<FileDownloadIcon size={22} />}
									className="text-btn-mailbox"
									loading={loadingDocs[`${doc.id}-download`]}
									disabled={loadingDocs[`${doc.id}-download`]}
									onClick={() => handleDownloadDoc(doc)}>
									{t('init.download')}
								</Button>
							</div>
						</div>
					);
				})}
		</Modal>
	);
};

export default MailboxModal;
